import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";

export default function Signup() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setMsg("");
    try {
      const data = await api.signup(username, password);
      setMsg(data.message || "Created. Awaiting admin approval.");
      setTimeout(() => nav("/login"), 700);
    } catch (e2) {
      setMsg(e2.message);
    }
  }

return (
  <div className="authWrap">
    <div className="card authCard">
      <div className="brandHeader">
        <img className="brandLogo" src="/logo512.png" alt="CRG Calculator" />
        <div className="brandText">
          <div className="brandTitle">CRG Calculator</div>
          <div className="brandTag">Precious Metals • Pt • Pd • Rh</div>
        </div>
      </div>

      <div className="cardHeader authHeader">
        <h2>Signup</h2>
        <div className="smallNote">Admin approval required</div>
      </div>

      <form onSubmit={submit} className="form">
        <label>Username</label>
        <input value={username} onChange={(e) => setUsername(e.target.value)} />

        <label>Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />

        <button type="submit" className="btnPrimary">Create account</button>
        {msg ? <div className="msg">{msg}</div> : null}
      </form>

      <div className="hint">Admin must approve before you can login.</div>
    </div>
  </div>
);
}